import type {Schemas} from 'api/dto.generated';
import {transformErrorResponse} from 'store/api';
import {ebsApi} from 'store/ebsApi';
import type {Lock, LockParams} from './types';
import {mapLockDto, mapLocksDto, mapOptionalLockDto} from './mappers';

export const locksApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getLocks: build.query<Lock[], void, Schemas.LocksDto>({
      query: () => `lock`,
      transformResponse: mapLocksDto,
    }),
    getLock: build.query<
      Lock | undefined,
      LockParams,
      Schemas.LockDto | undefined
    >({
      query: ({contextId, contextType}) =>
        `lock/v2/${contextType}/${contextId}`,
      transformResponse: mapOptionalLockDto,
      transformErrorResponse,
    }),
    postLock: build.mutation<Lock, LockParams, Schemas.LockDto>({
      query: ({contextId, contextType}) => ({
        url: `lock`,
        method: 'POST',
        body: {contextId, contextType},
      }),
      transformResponse: mapLockDto,
    }),
    acquireLock: build.mutation<Lock, Pick<Lock, 'id'>, Schemas.LockDto>({
      query: ({id}) => ({
        url: `lock/${id}/acquire`,
        method: 'PATCH',
      }),
      transformResponse: mapLockDto,
    }),
    deleteLock: build.mutation<void, Pick<Lock, 'id'>>({
      query: ({id}) => ({
        url: `lock/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetLocksQuery,
  useGetLockQuery,
  usePostLockMutation,
  useAcquireLockMutation,
  useDeleteLockMutation,
} = locksApi;
